import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=d81429b8&scoped=true&"
import script from "./Unsubscribe.vue?vue&type=script&lang=ts&"
export * from "./Unsubscribe.vue?vue&type=script&lang=ts&"
import style0 from "./Unsubscribe.vue?vue&type=style&index=0&id=d81429b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81429b8",
  null
  
)

export default component.exports